import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';

@Injectable()
export class RoleInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const role = localStorage.getItem('_switched_role');
    const switchTimestamp = localStorage.getItem('_switched_timestamp');

    // Si l'un des deux n'existe pas, on continue la requête normalement
    if (!role || !switchTimestamp) {
      return next.handle(req);
    }

    // On calcule le temps écoulé en minutes
    const elapsedMinutes = (Date.now() - Number(switchTimestamp)) / 60000;

    // Si plus de 60 minutes se sont écoulées, on continue la requête normalement
    if (elapsedMinutes > 60) {
      return next.handle(req);
    }

    const clone = req.clone({
      params: req.params.set('_switch_role', role)
    });

    return next.handle(clone);
  }
}
